import React, { PureComponent } from 'react';
import { Button } from '@eb/eds-button';
import { STYLE_FILL } from '@eb/eds-button';
import BasePackage from './_internal/BasePackage';
import Heading from './Heading';
import { DEFAULT_PACKAGE_TYPES } from '../constants/main';

export default class PackageOverview extends PureComponent {
    render() {
        const { heading, CTA, onClick, packages } = this.props;
        const packageItems = DEFAULT_PACKAGE_TYPES.map((value) => (
            <div
                key={value}
                className="eds-g-cell eds-g-cell-sw-4-12 eds-l-pad-vert-4"
            >
                <BasePackage adaptiveTextAlign={false} {...packages[value]} />
            </div>
        ));

        return (
            <div className="eds-bg-color--white eds-l-pad-bot-8">
                <div className="marketing-container__max-width">
                    <Heading
                        heading={heading}
                        alignCenter={true}
                        removeVerticalPadding={true}
                    />
                    <div className="marketing-container__max-width--medium">
                        {packageItems}
                    </div>
                    <div className="eds-g-cell eds-g-offset-1-12 eds-g-cell-10-12 eds-g-offset-sw-1-3 eds-g-cell-sw-1-3 eds-g-cell--has-overflow">
                        <div className="eds-align--center eds-l-pad-hor-4 eds-l-pad-vert-8 eds-l-sn-pad-vert-4 eds-l-sm-pad-vert-4">
                            <Button style={STYLE_FILL} onClick={onClick}>
                                {CTA}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
